module.exports = __webpack_public_path__ + "static/media/info-circle.923c42d4.svg";